module.exports = __webpack_public_path__ + "static/logo-170743dc62825ba1e170130de69dc76d.svg";